
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getStorage} from "firebase/storage";
import { getFirestore } from 'firebase/firestore';
import { FirebaseStorage } from "@firebase/storage";
import { StorageReference } from "@firebase/storage";
import { ref } from "@firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAGP3G5VjwzxQr5JLTTQ_s5ORJp6ZNKfTI",
  authDomain: "ronaldux-f5e97.firebaseapp.com",
  databaseURL: "https://ronaldux-f5e97.firebaseio.com",
  projectId: "ronaldux-f5e97",
  storageBucket: "ronaldux-f5e97.appspot.com",
  messagingSenderId: "1019409218791",
  appId: "1:1019409218791:web:6c05c75823efde6e0a7642",
  measurementId: "G-XJ21XEJW8X"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics();
export const storageF = getStorage();
export const db = getFirestore();